import React from "react";
import SectionDefault from "../../../components/sections/section-default";
import WideLayout from "../../../components/layouts/layout-wide";
import { Link } from "gatsby";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

export default function MQT() {
  return (
    <WideLayout>
      <div style={{ maxWidth: "1016px", margin: "0 auto" }}>
        <SectionDefault subheading="Multimodal Query Tool">
          <div className="uk-grid uk-child-width-1-1@m">
            <div className="uk-margin-top">
              <h3>How to Use This Tool</h3>
              <ol className="uk-list uk-list-decimal uk-list-collapse">
                <li>Use the filters to set your selection criteria</li>
                <li>Run multiple queries as needed (e.g. for control/test groups)</li>
                <li>Download the NACCIDs for the participants that meet your selections criteria</li>
                <li>
                  Record the filters for your selection so they can be used as a reproducible record for publications
                  (your filter selections are listed in the top right corner of the tool)
                </li>
                <li>
                  Request full NACC data sets via the{" "}
                  <a href="https://nacc.redcap.rit.uw.edu/surveys/?s=KHNPKLJW8TKAD4DA" target="_blank" rel="noreferrer">
                    NACC Quick Access File Data Request System
                  </a>{" "}
                  (Sign a DUA to access Quick Access Files for a variety of data modalities)
                </li>
                <li>
                  Use your preferred statistical software to restrict the Quick Access File data to the participants
                  that met your criteria
                </li>
                <li>
                  Use the NACCID list for your participant selection (“shopping list”) to expedite accessing additional
                  data modalities for these participants from partner repositories (e.g. NCRAD, NIAGADS, ADKP, and LONI)
                </li>
              </ol>

              <Link to="/data-front-door#multimodal%20query%20tool%20mqt" className="bolder">
                <FontAwesomeIcon icon={faArrowLeft} className="uk-margin-small-right" />
                Read more about the purpose of this tool
              </Link>

              <div className="uk-width-1-1 uk-flex uk-flex-between uk-flex-wrap uk-margin-top">
                <div>
                  <p className="uk-text-italic uk-width-medium ">
                    The MQT-v1 release is a prototype and is undergoing validation and further development. We’re
                    developing new features, with a major update planned for release in late Q3 2025. There are some
                    minor discrepancies between data that is searchable via the MQT and the March 2025 data freeze Quick
                    Access File (QAF). Please keep this in mind as you are using the tool and reach out to us if you
                    have any questions (<a href="mailto:nacchelp@uw.edu">nacchelp@uw.edu</a>). This will be resolved
                    once the NACC QAF is migrated to the new NACC Data Platform in Q4 2025.
                  </p>
                </div>
                <div>
                  <iframe
                    src="https://www.youtube-nocookie.com/embed/Nz1fYQYhIKE?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=0"
                    width="500"
                    height="281"
                    allowfullscreen
                    data-uk-responsive
                    data-uk-video="false"
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="uk-margin-top">
              <div className="uk-card uk-card-primary uk-card-body uk-card-small">
                <p
                  className="text-body uk-margin-remove-bottom uk-width-xlarge uk-margin-auto"
                  style={{ textWrap: "balance", textAlign: "center" }}
                >
                  The Multimodal Query Tool (MQT) is actively evolving. Please take 5 minutes to share your thoughts via
                  this{" "}
                  <a href="https://nacc.redcap.rit.uw.edu/surveys/?s=JJ8YEDAARXHE7DWE" target="_blank" rel="noreferrer">
                    feedback form
                  </a>
                  . Your input will directly inform future versions and help us better support your research.
                </p>
              </div>
            </div>
          </div>
        </SectionDefault>
      </div>
      <iframe
        src="https://mqt.flywheel.naccdata.org/"
        width="1016px"
        title="Multimodal Query Tool"
        style={{ border: "none", margin: "0 auto", display: "block", borderRadius: "5px", minHeight: "2800px" }}
      ></iframe>
    </WideLayout>
  );
}
